import { run } from './bootstrap'



/**
 * 
 */
const customPortalDomain = process.env.CUSTOM_PORTAL_DOMAIN
// 找商机域名
const businessOrigin = process.env.BUSINESS_ORIGIN
// 找供应商域名
const supplierOrigin = process.env.SUPPLIER_ORIGIN

// 判断是否是自定义门户域名
const isCustomPortal = window.location.hostname.includes(customPortalDomain || '')

const pathname = window.location.pathname

/**
 * todo 
 * 1. 根据pathname 去访问对应的域名 （要在router内维护一个 域名和path的映射关系）
 * 2. 如果pathname 是 / ，则访问自定义门户域名
 * 3. 如果pathname 是 /find-business，则访问找商机域名
 * 4. 如果pathname 是 /find-supplier，则访问找供应商域名
 * 5. 如果pathname 是 /find-business/detail，则访问找商机域名
 * 6. 如果pathname 是 /find-supplier/detail，则访问找供应商域名
 * 7. 如果pathname 是 /find-business/detail/123，则访问找商机域名
 */


// 
if(customPortalDomain && isCustomPortal && pathname === "/" && businessOrigin !== window.location.origin){
    window.location.href = `${window.location.origin}/company`
} else {
    run()
}
